/* eslint-disable no-param-reassign */
// param reassignment allowed by RTK
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
	compareVehicles: [],
	compareBarVisible: false
};

export const compareSlice = createSlice({
	name: 'compareVehicles',
	initialState,
	reducers: {
		addCompareVehicle(state, action) {
			state.compareVehicles = [...state.compareVehicles, action.payload];
		},
		removeCompareVehicle(state, action) {
			state.compareVehicles = state.compareVehicles.filter(
				(vehicleUUID) => vehicleUUID !== action.payload
			);
		},
		setCompareBarVisible(state, action) {
			state.compareBarVisible = action.payload;
		}
	}
});

export const { addCompareVehicle, removeCompareVehicle, setCompareBarVisible } =
	compareSlice.actions;

export default compareSlice.reducer;
